"use client";
import BulkOfferDesktop from "./bulk-offer/BulkOfferDesktop";
import BulkOfferMobile from "./bulk-offer/BulkOfferMobile";
import {useCurrentDeviceContext} from "@/context/DeviceContext";

interface Props {
  desktopClassName?: string;
  largeButton?: boolean;
}

export default function BulkOffer(props: Props) {
  const { largeButton = true } = props;
  const deviceContext = useCurrentDeviceContext()
  const isMobile = deviceContext.device === "mobile";

  return (
    <section>
      {isMobile && <BulkOfferMobile />}
      {!isMobile && (
        <BulkOfferDesktop
          largeButton={largeButton}
          desktopClassName={props.desktopClassName}
        />
      )}
    </section>
  );
}
